var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"message-box"},[_c('div',{staticClass:"message-box-content"},[_c('h2',[_vm._v("温馨提示")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('div',{on:{"click":_vm.handleClick}},[_vm._v("我知道了")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }